/** Small formatting helpers + API field-error parsing. */
export { fmtDate, fmtDateTime } from "@/lib/datetime";

export const fmtPrice = (v) => {
  if (v == null || v === "") return null;
  return new Intl.NumberFormat(undefined, { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(v);
};

export const priceRange = (min, max) => {
  const a = fmtPrice(min);
  const b = fmtPrice(max);
  if (a && b) return `${a} – ${b}`;
  if (a) return `${a}+`;
  if (b) return `Up to ${b}`;
  return null;
};

/** Amounts are stored in integer cents. */
export const fmtCents = (v) => (v == null || v === "" ? "—" : fmtPrice(v / 100));

/** Map backend 422 error payload to a { field: message } object. */
export const parseFieldErrors = (err) => {
  const list =
    err?.details?.errors ||
    err?.error?.details?.errors ||
    err?.response?.data?.error?.details?.errors ||
    [];
  const map = {};
  list.forEach((e) => {
    const f = e.loc?.[e.loc.length - 1];
    if (f) map[f] = (e.msg || "").replace("Value error, ", "");
  });
  return map;
};
